import { Link } from "react-router-dom";
import type { WorkItem } from "@/utils/videoUtils";
import { formatViews } from "@/utils/videoUtils";

interface WorkCardProps {
  work: WorkItem;
  showViews?: boolean;
}

export default function WorkCard({ work, showViews = false }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors duration-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - 日本伦理剧`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-label bg-primary-950/70 text-background-50 backdrop-blur-sm">
          {work.type}
        </span>
        {work.rating !== null && (
          <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-label bg-accent-500 text-accent-950">
            <i className="ri-star-fill text-[10px]"></i>
            {work.rating.toFixed(1)}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-primary-950/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-xs text-background-100 line-clamp-2">{work.synopsis}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-foreground-950 text-base font-semibold line-clamp-1 group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <div className="mt-1 flex items-center gap-2 text-xs text-foreground-600 font-label">
          <span>{work.year}</span>
          <span className="text-background-300">·</span>
          <span>{work.genre}</span>
          {showViews && (
            <>
              <span className="text-background-300">·</span>
              <span>{formatViews(work.views)} 浏览</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}